const toPersianNumber = (number) => {
    if (typeof number !== "undefined" && number !== null) {
        const farsiDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
        let temp = number.toString().replace(/\d/g, (x) => farsiDigits[x]);
        return temp
    } else return ''
};
export default toPersianNumber